import { render, staticRenderFns } from "./TradeLogistic.vue?vue&type=template&id=f39cd466&scoped=true"
import script from "./TradeLogistic.vue?vue&type=script&lang=js"
export * from "./TradeLogistic.vue?vue&type=script&lang=js"
import style0 from "./TradeLogistic.vue?vue&type=style&index=0&id=f39cd466&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39cd466",
  null
  
)

export default component.exports